//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBillingPeriodController_findAll,
  Response$AdminBillingPeriodController_findAll$Status$200,
  ResponseContentType$AdminBillingPeriodController_findAll,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminBillingPeriodController_findAll = (options: {
  params: Params$AdminBillingPeriodController_findAll['parameter'];
  config?: QueryOptions<
    Response$AdminBillingPeriodController_findAll$Status$200[ResponseContentType$AdminBillingPeriodController_findAll]
  >;
}) =>
  useApiClient<
    Params$AdminBillingPeriodController_findAll,
    Response$AdminBillingPeriodController_findAll$Status$200[ResponseContentType$AdminBillingPeriodController_findAll]
  >({
    method: 'AdminBillingPeriodController_findAll',
    params: { parameter: options.params },
    config: options.config,
  });
